import './disable-console';

import { registerLocaleData } from '@angular/common';
import localeEnIn from '@angular/common/locales/en-IN';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';

/** Required for `number` pipe with `'en-IN'` (Indian digit grouping) to apply correctly. */
registerLocaleData(localeEnIn);

bootstrapApplication(AppComponent, appConfig).catch((err) =>
    console.error(err)
);
